import { TrackLinkDirective } from '@analytics/events';
import { Component, computed, input } from '@angular/core';
import {
  CoreJssProxyModule,
  TextField,
  type LinkField,
  type RichTextField,
} from '@core/jss-proxy';
import {
  GenericLinkDirective,
  GenericRichTextDirective,
} from '@core/jss-utils';
import type { IconIcon } from '@essent/current-web';
import {
  CrntButton,
  CrntButtonAlt,
  CrntIcon,
} from '@essent/current-web-angular';

@Component({
  selector: 'wl-contact-item',
  standalone: true,
  imports: [
    CoreJssProxyModule,
    CrntIcon,
    CrntButton,
    CrntButtonAlt,
    TrackLinkDirective,
    GenericLinkDirective,
    GenericRichTextDirective,
  ],
  templateUrl: './contact-item.component.html',
  styleUrls: [
    './contact-item.component.ed.scss',
    './contact-item.component.essent.scss',
  ],
})
export class ContactItemComponent {
  readonly uid = input.required<string>();
  readonly icon = input.required<IconIcon | undefined>();
  readonly title = input.required<TextField | undefined>();
  readonly description = input.required<RichTextField | undefined>();
  readonly alternativeButton = input<LinkField | undefined>();
  readonly chatButton = input<TextField | undefined>();

  readonly showChatButton = computed(() => this.chatButton()?.value);
  readonly showAlternativeButton = computed(
    () => !this.showChatButton() && this.alternativeButton()?.value
  );
}
